import * as React from 'react';
import { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { ShowChange } from '../models/configuration/ShowChange';
import { DataStore } from '../stores';
import ChangeIndicatorValue from './ChangeIndicatorValue';
import ChangeIndicatorIcon from './ChangeIndicatorIcon';
import { computed, observable } from 'mobx';

interface ChangeIndicatorProps {
    dataStore: DataStore;
    theme?: { [property: string]: string | number };
    value: string | number;
    separator?: string;
    alignIcon?: 'right' | 'left' | null;
    upIcon?: string;
    downIcon?: string;
    noChangeIcon?: string;
    showChange?: ShowChange;
}

@observer
class ChangeIndicator extends Component<ChangeIndicatorProps> {
    @observable value;
    @observable showChange;
    @observable alignIcon;

    constructor(props) {
        super(props);
        this.showChange = props.showChange || props.dataStore.defaultShowChange;
        this.value = props.value;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.value = this.props.value;
        }
    }

    @computed
    get valueAsNumber() {
        const { value } = this;
        // Depending on format codes used values maybe a string or number, e.g. "-4.2%" or -4.2
        // So if the value is not a number strip of any non-numeric characters (except "." & "-") then parseFloat.
        return isNaN(value as number) && value !== '-'
            ? parseFloat(`${value}`.replace(/[^0-9.-]/g, ''))
            : value;
    }

    @computed
    get changeIndicatorOptions() {
        const {
            theme,
            upIcon = 'ChangeUpIcon',
            downIcon = 'ChangeDownIcon',
            noChangeIcon = 'NoChangeIcon',
        } = this.props;

        const { changeUpColor, changeDownColor } = this.showChange;
        const options = {
            changeTheme: theme.NoChangeIcon,
            color: null,
            filename: noChangeIcon,
        };

        if (this.valueAsNumber > 0) {
            options.changeTheme = theme.ChangeValueUp;
            options.color = changeUpColor;
            options.filename = upIcon;
        } else if (this.valueAsNumber < 0) {
            options.changeTheme = theme.ChangeValueDown;
            options.color = changeDownColor;
            options.filename = downIcon;
        }

        return options;
    }

    @computed
    get changeIndicatorValue() {
        const { showValue = true } = this.showChange;
        if (showValue) {
            const { theme, value } = this.props;
            const { color, changeTheme } = this.changeIndicatorOptions;
            return (
                <ChangeIndicatorValue
                    changeTheme={changeTheme}
                    color={color}
                    theme={theme}
                    value={value}
                />
            );
        }
    }

    @computed
    get changeIndicatorIcon() {
        const { showIcon = true } = this.showChange;
        const placeholder = this.props.dataStore.config.noDataPlaceholder;
        if (showIcon && this.value !== placeholder) {
            const { theme } = this.props;
            const { filename, changeTheme } = this.changeIndicatorOptions;
            return (
                <ChangeIndicatorIcon
                    theme={theme}
                    filename={filename}
                    changeTheme={changeTheme}
                />
            );
        }
    }

    render() {
        const { separator, alignIcon = 'right' } = this.props;
        const { changeIndicatorIcon, changeIndicatorValue } = this;

        return (
            <Fragment>
                {alignIcon === 'left' && changeIndicatorIcon}
                {changeIndicatorValue}
                {(!alignIcon || alignIcon === 'right') && changeIndicatorIcon}
                {separator}
            </Fragment>
        );
    }
}

export default withTheme(ChangeIndicator);



// WEBPACK FOOTER //
// ./src/Components/ChangeIndicator.tsx